<a class="skip-link" href="#main-content">{{ 'common.skip' | t }}</a>
<ds-header
  [tagline]="'common.brandTagline' | t"
  [navigationLabel]="'common.primaryNavigation' | t"
  [menuLabel]="'common.primaryNavigation' | t"
  [menuOpen]="mobileMenuOpen()"
  (menuOpenChange)="mobileMenuOpen.set($event)"
>
  <div dsHeaderNav class="site-navigation">
    <a
      dsButton
      variant="quiet"
      routerLink="/"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="active"
      (click)="closeMobileMenu()"
      >{{ 'common.home' | t }}</a
    >
    @for (category of categoryLinks(); track category.href) {
      <a
        dsButton
        variant="quiet"
        [routerLink]="category.href"
        [queryParams]="{ topic: category.category }"
        fragment="directory-heading"
        (click)="closeMobileMenu()"
        >{{ category.label }}</a
      >
    }
    <a dsButton variant="quiet" [href]="aboutLink()" (click)="closeMobileMenu()">{{
      'common.about' | t
    }}</a>
  </div>
  <div dsHeaderActions class="site-header-actions">
    <label class="header-language">
      <span class="ds-visually-hidden">{{ 'common.language' | t }}</span>
      <select
        [value]="currentLanguage()"
        [attr.title]="'common.language' | t"
        [disabled]="languageChangePending()"
        [attr.aria-busy]="languageChangePending()"
        (change)="changeLanguage($event)"
      >
        @for (language of languages(); track language.code) {
          <option [value]="language.code" [selected]="language.code === currentLanguage()">
            {{ language.nativeName }}
          </option>
        }
      </select>
    </label>
    <a dsButton variant="quiet" routerLink="/account" (click)="closeMobileMenu()">Account</a>
    <a dsButton routerLink="/" (click)="closeMobileMenu()">{{ 'common.startTest' | t }}</a>
  </div>
</ds-header>
@if (languageChangeNotice()) {
  <div class="language-notice" role="status" aria-live="polite">
    <p>{{ languageChangeNotice() }}</p>
    <button dsButton type="button" variant="quiet" size="small" (click)="dismissLanguageNotice()">
      Dismiss
    </button>
  </div>
}
<div class="site-page"><router-outlet /></div>
<ds-footer [navigationLabel]="'common.footerNavigation' | t">
  <div dsFooterNav class="site-footer-navigation">
    <a [href]="contentLink()">{{ 'common.iqGuides' | t }}</a>
    <a href="/en/legal/privacy-policy/">Privacy</a>
    <a href="/en/legal/terms-and-conditions/">Terms</a>
    <a href="/en/legal/cookie-policy/">Cookies</a>
    <a href="/en/legal/refund-policy/">Refunds</a>
    <a href="/en/legal/">Legal center</a>
    <a href="/practice/">Daily challenge</a>
    <a href="/accessibility/">Accessibility</a>
    <a href="/en/methodology/">Methodology</a>
    <a href="/en/editorial-standards/">Editorial standards</a>
  </div>
  <p>&copy; 2026 IQLabTest. {{ 'common.footerNote' | t }}</p>
</ds-footer>
